// Vendor imports
const classNames = require('classnames')
const PropTypes = require('prop-types')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const { CircleButton } = require('client-v2/common/components/buttons')

const bem = BemEntity('OpenInAppButton')

function OpenInAppButton(props) {
  // Internal state
  const [ isVisible ] = React.useState(props.initialIsVisible)
  const [ isDismissed, setDismissed ] = React.useState(false)
  // Event handlers
  const { onClick } = props
  const handleClick = React.useCallback(
    event => {
      event.stopPropagation()
      setDismissed(true)
      onClick()
    },
    [ onClick, setDismissed ]
  )
  const { onDismiss } = props
  const handleDismiss = React.useCallback(
    event => {
      event.stopPropagation()
      setDismissed(true)
      onDismiss()
    },
    [ onDismiss, setDismissed ]
  )
  // Rendering
  if (!isVisible) {
    return null
  }
  return (
    tag('div', {
      'aria-label': 'Open in App',
      className: classNames(
        props.className,
        bem.block({ dismissed: isDismissed })
      ),
      role: 'button',
      tabIndex: 0,
      onClick: handleClick
    },
      'Open in App',
      tag(CircleButton, {
        'aria-label': `Dismiss the 'Open in App' prompt`,
        className: bem.element('close'),
        onClick: handleDismiss
      })
    )
  )
}

OpenInAppButton.propTypes = {
  // Flags
  initialIsVisible: PropTypes.bool,
  // Values
  className: PropTypes.string,
  // Callbacks
  onClick: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired
}

module.exports = OpenInAppButton
